import _createClass from "E:\\FIVER284-paralight\\mintsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _classCallCheck from "E:\\FIVER284-paralight\\mintsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _inherits from "E:\\FIVER284-paralight\\mintsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "E:\\FIVER284-paralight\\mintsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
import _wrapNativeSuper from "E:\\FIVER284-paralight\\mintsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/wrapNativeSuper";
export var ProviderRpcError = /*#__PURE__*/function (_Error) {
  _inherits(ProviderRpcError, _Error);
  var _super = _createSuper(ProviderRpcError);
  function ProviderRpcError(error) {
    var _this;
    _classCallCheck(this, ProviderRpcError);
    _this = _super.call(this, error.message);
    _this.message = error.message;
    _this.code = error.code;
    _this.data = error.data;
    return _this;
  }
  return _createClass(ProviderRpcError);
}( /*#__PURE__*/_wrapNativeSuper(Error));